import { render, staticRenderFns } from "./SalesApproval.vue?vue&type=template&id=8ec183aa&scoped=true"
import script from "./SalesApproval.vue?vue&type=script&lang=js"
export * from "./SalesApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec183aa",
  null
  
)

export default component.exports